// Home.tsx

import { useTranslation } from "react-i18next";
import ContactSection from "../components/ContactSection";
import Logos from "../components/Logos";

export default function Home() {
  const { t } = useTranslation();

  return (
    <section className="space-y-10 overflow-hidden">

      {/* HERO */}
      <div className="relative bg-slate-50 overflow-hidden py-14 sm:py-20 px-4 sm:px-6 lg:px-12">

  <div className="max-w-7xl mx-auto grid grid-cols-1 [@media(min-width:1200px)]:grid-cols-2 gap-12 lg:gap-16 items-center">

    {/* TEXT */}
    <div className="space-y-8 lg:space-y-10 text-center [@media(min-width:1200px)]:text-left items-center [@media(min-width:1200px)]:items-start flex flex-col">

      <h1
  className="
    max-w-[700px]
    text-[2.2rem]
    sm:text-[3rem]
    lg:text-[3rem]
    font-black
    leading-[1.05]
    lg:leading-[1.1]
    tracking-tight
    break-words
    mx-auto
    [@media(min-width:1200px)]:mx-0
  "
>
  {t("home.hero.title1")} <br />

  <span className="text-blue-600 italic">
    {t("home.hero.highlight")}
  </span>
</h1>

<p
  className="
    text-base
    sm:text-lg
    lg:text-xl
    text-slate-500
    max-w-xl
    leading-relaxed
    mx-auto
    [@media(min-width:1200px)]:mx-0
  "
>
  {t("home.hero.subtitle")}
</p>

      <button
        onClick={() =>
          window.open("https://tech-interview.com/", "_blank")
        }
        className="w-full sm:w-auto bg-blue-600 text-white px-8 sm:px-10 py-4 rounded-2xl font-bold uppercase text-sm tracking-wider shadow-xl hover:bg-blue-700 transition mx-auto [@media(min-width:1200px)]:mx-0"
      >
        {t("home.hero.button")}
      </button>

    </div>

    {/* IMAGE */}
    <div className="relative flex justify-center group">

      <div className="absolute inset-0 bg-blue-400/10 blur-[120px] rounded-full"></div>

      <img
        src="https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=1200"
        className="relative z-10 w-full max-w-[650px] rounded-[28px] sm:rounded-[40px] border-4 sm:border-8 border-white shadow-2xl transition group-hover:scale-105"
      />

    </div>

  </div>
</div>

      {/* CARDS */}
      <div className="max-w-[1450px] mx-auto grid sm:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-10 px-4 sm:px-6 lg:px-8">
  {(t("home.cards", { returnObjects: true }) as string[]).map(
    (item, i) => {
      const images = [
        "https://optim.tildacdn.net/tild3238-6364-4631-b539-666363656666/-/cover/393x309/center/center/-/format/webp/cuspydesign_A_group_.png.webp",
        "https://optim.tildacdn.net/tild6638-6661-4264-b133-646637646134/-/cover/393x309/center/center/-/format/webp/cuspydesign_A_group_.png.webp",
        "https://optim.tildacdn.net/tild3464-6336-4835-b334-323938393662/-/cover/393x309/center/center/-/format/webp/cuspydesign_A_group_.png.webp",
      ];

      return (
        <div
          key={i}
          className="rounded-3xl border border-slate-100 bg-white overflow-hidden shadow-sm transition hover:-translate-y-3 hover:border-blue-600"
        >
          {/* IMAGE */}
          <div className="h-48 sm:h-56 lg:h-60 overflow-hidden">
            <img
              src={images[i]}
              alt={item}
              className="w-full h-full object-cover transition duration-500 hover:scale-105"
            />
          </div>

          {/* CONTENT */}
          <div className="p-8 sm:p-10 lg:p-12">
            <h4 className="mb-5 text-sm sm:text-base font-black uppercase tracking-widest text-slate-900 text-center">
              {item}
            </h4>

            <p className="text-sm sm:text-base leading-relaxed text-slate-500 text-center">
              {t(`home.cardsDesc${i}`)}
            </p>
          </div>
        </div>
      );
    }
  )}
</div>

      {/* LOGOS */}
     <Logos/>

      {/* WHY */}
      <div className="bg-slate-50 py-16 sm:py-24 lg:py-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1450px] mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">

          {/* LEFT */}
          <div className="space-y-8 lg:space-y-10">

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black leading-tight">
              {t("home.why.title")}
            </h2>

            <p className="text-base sm:text-lg lg:text-xl text-slate-500 leading-relaxed max-w-xl">
              {t("home.why.subtitle")}
            </p>

            <div className="grid sm:grid-cols-2 gap-6 lg:gap-8">

              <div className="rounded-3xl border bg-white p-6 sm:p-8 shadow-sm">
                <h5 className="mb-3 text-sm font-black uppercase tracking-wider text-blue-600">
                  {t("home.why.agility.title")}
                </h5>

                <p className="text-sm text-slate-500 leading-relaxed">
                  {t("home.why.agility.desc")}
                </p>
              </div>

              <div className="rounded-3xl border bg-white p-6 sm:p-8 shadow-sm">
                <h5 className="mb-3 text-sm font-black uppercase tracking-wider text-blue-600">
                  {t("home.why.expertise.title")}
                </h5>

                <p className="text-sm text-slate-500 leading-relaxed">
                  {t("home.why.expertise.desc")}
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="grid grid-cols-2 gap-4 sm:gap-8 text-center">
            {[
              ["6+", "home.stats.exp"],
              ["25", "home.stats.partners"],
              ["5", "home.stats.awards"],
              ["50+", "home.stats.team"],
            ].map(([num, label]) => (
              <div
                key={label}
                className="rounded-3xl border bg-white p-6 sm:p-10 lg:p-12 shadow-sm hover:shadow-md transition"
              >
                <p className="text-3xl sm:text-4xl lg:text-5xl font-black text-blue-600">
                  {num}
                </p>

                <p className="mt-2 text-[10px] sm:text-sm uppercase tracking-wider text-slate-400">
                  {t(label)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* VIDEO */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="aspect-video overflow-hidden rounded-[24px] sm:rounded-[40px] shadow-2xl">
          <iframe
            className="h-full w-full"
            src="https://www.youtube.com/embed/VkgsD0yv4b8?si=pq59y7vWd7QdrwBK"
            allowFullScreen
          />
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="max-w-[1450px] mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">

        <h3 className="text-4xl sm:text-4xl font-black text-center mb-6">
          {t("home.testimonials.title")}
        </h3>

        <p className="max-w-2xl mx-auto mb-12 sm:mb-16 text-center text-base sm:text-lg text-slate-500">
          {t("home.testimonials.desc")}
        </p>

        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-10">
          {(
            t("home.testimonials.items", {
              returnObjects: true,
            }) as {
              name: string;
              role: string;
              text: string;
            }[]
          ).map((item, i) => {
            const icons = [
              "https://static.tildacdn.net/tild3962-6436-4538-b930-633966343165/resources.png",
              "https://static.tildacdn.net/tild6334-6364-4738-b563-656136626538/resources_1.png",
              "https://static.tildacdn.net/tild3638-3366-4132-b966-306430663630/resources.png",
            ];

            return (
              <div
                key={i}
                className="rounded-3xl border bg-slate-50 p-8 sm:p-10 lg:p-12 shadow-sm transition hover:-translate-y-2"
              >
                <div className="mb-6 flex items-center gap-4">
                  <img
                    src={icons[i]}
                    alt={item.name}
                    className="h-14 w-14 sm:h-16 sm:w-16 rounded-2xl bg-white p-2 object-contain shadow-sm"
                  />

                  <div>
                    <p className="text-base font-black text-slate-900">
                      {item.name}
                    </p>

                    <p className="text-sm text-slate-500">
                      {item.role}
                    </p>
                  </div>
                </div>

                <p className="italic leading-relaxed text-slate-600 text-sm sm:text-base">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      <ContactSection />
    </section>
  );
}